module.exports = __webpack_public_path__ + "static/media/edit-button.8a9934f2.svg";